import { getTwoLetterIsoLanguageName, getTwoLetterIsoName } from 'helpers/utilities';
import { useSelector } from 'react-redux';
import { bikeModelSelector, bikeColourSelector } from 'src/redux/bike/selectors';
import { getGoalId } from 'src/redux/app/selectors';
import fetchGoal from 'helpers/goals';
import useDataLayer from './useDataLayer';
import useBikeTotal from './useBikeTotal';

const useOpenFinance = () => {
  const bikeModel = useSelector(bikeModelSelector);
  const { thumbnail } = bikeModel;
  const openFinanceGoalId = useSelector(getGoalId('finance Calculator'));
  const pushToDataLayer = useDataLayer();
  const bikeColour = useSelector(bikeColourSelector);
  const total = useBikeTotal();
  const assetId = `${bikeModel.year}${bikeModel.productCode}${bikeColour.colourCode}`;

  const openFinanceCalculator = () => {
    pushToDataLayer('configuratorFinance');

    if (window.financeCalculator.canOpenScfModal()) {
      window.financeCalculator.openScfModal({ noCtaEvents: true });

      fetchGoal(openFinanceGoalId);
    }

    if (window.codeweavers && window.financeCalculator) {
      window.financeCalculator.openCodeweaversModal({
        noCtaEvents: true,
        financeCapCode: bikeColour.capCode,
        financeAmount: total,
        financeShowImage: thumbnail?.src,
        languageCode: getTwoLetterIsoLanguageName(),
        countryCode: getTwoLetterIsoName(),
        assetId,
      });

      fetchGoal(openFinanceGoalId);
    }
  };

  return openFinanceCalculator;
};

export default useOpenFinance;
